import { Box } from '@robocorp/components';
import { styled } from '@robocorp/theme';

/**
 * A layout helper conmponent that makes the content "sticky" at a fixed position to the parent scrolling container.
 */
export const Sticky = styled(Box)<{ $top?: number }>`
  position: sticky;
  top: ${({ $top }) => $top || 0}px;
  left: 0px;
  z-index: 10;
`;
